'use strict';
var Backbone = require('backbone');

module.exports = Backbone.Model.extend({
    defaults: {
        // data supplied values
        id: null,
        active: '1',
        name: null,
        twitter_handle_1: null,
        twitter_handle_2: null,
        image: '',
        image_small: '',
        maxVotes: 0,
        // model supplied values,
        voteCount: 0,
        voteAllocated: 0,
        selected: false,
        lastSubmitted: 0
    },
    /**
     *
     */
    initialize: function () {
        //updated image to be https
        if(this.get('image').indexOf('http://ts-cms-production.votenow.tv/') > -1) {
            this.set('image', this.get('image').replace('http://', 'https://'));
        }
        //updated image to be https
        if(this.get('image_small').indexOf('http://ts-cms-production.votenow.tv/') > -1) {
            this.set('image_small', this.get('image_small').replace('http://', 'https://'));
        }
    }
});



// WEBPACK FOOTER //
// ./app/scripts/models/vote-option.js